module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Light.0b78ec9d.otf";